/*
  Philosophy section — scroll-driven reveal for .r-up elements.
  Mirrors the measure/updThread pattern from the source (index.html §services),
  adapted for this section's elements (no thread SVG present in philosophy).
  Global.js runs a page-wide pass; this block ensures correctness when the
  section is injected after initial load or global.js is deferred.
*/
(function () {
  var sec = document.getElementById('philosophy');
  if (!sec) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ups = Array.prototype.slice.call(sec.querySelectorAll('.r-up'));
  if (!ups.length) return;

  /* If global.js already processed these elements, bail early */
  if (ups[0].classList.contains('in')) return;

  /* Reduced-motion or no IO support: reveal immediately (static state) */
  if (reduce || !('IntersectionObserver' in window)) {
    ups.forEach(function (el) { el.classList.add('in'); });
    return;
  }

  /* Scroll-driven reveal — scoped to #philosophy */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) {
        en.target.classList.add('in');
        io.unobserve(en.target);
      }
    });
  }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });

  ups.forEach(function (el) { io.observe(el); });
})();
